import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

import login from './routers/login.js'
import dashboard from './routers/dashboard.js'
import user from './routers/user.js'
import study from './routers/study.js'
import guest from './routers/guest.js'

var routes = login
routes = routes.concat(dashboard)
routes = routes.concat(user)
routes = routes.concat(study)

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes,
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  store.commit('refresh')
  document.title = to.meta.title + ' - ComTrial Express EDC'
  if (!store.getters.online && guest.indexOf(to.path) < 0) {
    next({
      path: '/',
      name: 'login',
      query: { redirect: to.fullPath }
    })
  } else if (store.getters.online && to.path === '/') {
    next({
      path: '/dashboard',
      name: 'dashboard',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
})

router.afterEach((to, from) => {
  if (guest.indexOf(to.path) < 0 && store.getters.routes.indexOf(to.name) < 0 && to.path !== '/dashboard') {
    router.push({
      path: '/no-auth',
      query: { redirect: to.fullPath }
    })
  }
})

export default router
